import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  productListParams,
  productListQueryOptions,
  productListSearchSchema,
  ProductsListPage,
} from '@/features/products';

export const Route = createFileRoute('/_authed/_active/org/products/')({
  staticData: { tours: ['catalog.products'] },
  // Typed as the raw input so links into the list (`<Link to="/org/products">`) need no search.
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) =>
    productListSearchSchema.parse(search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'products.read');
  },
  loader: async ({ context, deps, cause }) => {
    const prefetch = context.queryClient
      .query({ ...productListQueryOptions(productListParams(deps)), staleTime: 'static' })
      .catch(() => undefined);
    // A filter, sort or page change on the list itself must not wait for the fetch, or a second
    // pick in the filter picker would build on stale filters (see the orders route).
    if (cause !== 'stay') await prefetch;
  },
  component: ProductsListPage,
});
